module.exports = __webpack_public_path__ + "27abec0e6c1b36d02d98555beeba8c07.png";